import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { AppComponent } from './app.component';
import { TestComponent } from './test/test.component';
import { AppRoutingModule } from './app-routing.module';
import { ConfirmationService } from 'primeng/api';
import { providePrimeNG } from 'primeng/config';

import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptorFn } from './auth/auth-interceptor.service';
import { provideTranslateService, provideTranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader, provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { SnackbarComponent } from './shared/snackbar/snackbar.component';
import { ComingSoonComponent } from './coming-soon/coming-soon.component';
import { AuthModule } from './auth/auth.module';
import { CoreUiModule } from './shared/core-ui.module';
import { ShellModule } from './shared/shell.module';
import es from '@angular/common/locales/es';
import en from '@angular/common/locales/en';
import { DatePipe, registerLocaleData } from '@angular/common';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { AMERICAN_DATE_FORMATS } from './shared/constants/date-formats';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';

registerLocaleData(es);
registerLocaleData(en);

@NgModule({
    declarations: [
        AppComponent,
        TestComponent,
        SnackbarComponent,
        ComingSoonComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,        CoreUiModule,
        AuthModule,
        ShellModule,
        ServiceWorkerModule.register('custom-sw.js', {
            enabled: environment.production,
            updateViaCache: 'none',
            registrationStrategy: 'registerWhenStable:30000'
        }),
    ],
    providers: [
        provideTranslateService({
            lang: 'es',
            loader: provideTranslateLoader(TranslateHttpLoader),
        }),
        provideTranslateHttpLoader({
            prefix: './assets/i18n/',
            suffix: '.json'
        }),
        DatePipe,
        provideHttpClient(withInterceptors([authInterceptorFn])),
        provideAnimationsAsync(),
        { provide: LOCALE_ID, useValue: 'es-ES' },
        { provide: MAT_DATE_LOCALE, useValue: 'en-US' },
        { provide: MAT_DATE_FORMATS, useValue: AMERICAN_DATE_FORMATS },
        providePrimeNG({
            zIndex: {
                modal: 1100,
                overlay: 1200,
                menu: 1300,
                tooltip: 1400
            }
        }),
        ConfirmationService,
    ],
    bootstrap: [AppComponent]
})
export class AppModule { }
